import { Button, Form, Input, Modal } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { loadSingleStaff, updateUser } from "../../../redux/rtk/features/user/userSlice";
import BtnEditSvg from "../Button/btnEditSvg";

const AddressEditPopup = ({ userId, user }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const {id} = useParams();

    // Prefill form with existing user address data when modal opens
    useEffect(() => {
        if (isModalOpen) {
            console.log("Setting form values:", user);
            form.setFieldsValue({
                street: user?.street || "",
                city: user?.city || "",
                state: user?.state || "",
                zipCode: user?.zipCode || "",
                country: user?.country || "",
                pAddress: user?.pAddress || "",
                pCity: user?.pCity || "",
                pState: user?.pState || "",
                pZipCode: user?.pZipCode || "",
                pCountry: user?.pCountry || "",
            });
        }
    }, [isModalOpen, user, form]);
    
    

    const showModal = () => {
        setIsModalOpen(true);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
        form.resetFields();
    };

    const onFinish = async (values) => {
        try {
            const updateValues = {
                
                    street: values.street,
                    city: values.city,
                    state: values.state,
                    zipCode: values.zipCode,
                    country: values.country,
                
                
                    pAddress: values.pAddress,
                    pCity: values.pCity,
                    pState: values.pState,
                    pZipCode: values.pZipCode,
                    pCountry: values.pCountry
                
            };
    
            console.log("Sending Update:", updateValues);
    
            const response = await dispatch(updateUser({ id: userId, values: updateValues }));
            console.log("API Response:", response);
    
            if (response.payload?.message === "success") {
                await dispatch(loadSingleStaff(id));
                console.log("Reloaded user data");
                setIsModalOpen(false);
                form.resetFields();
            } else {
                console.error("Update failed:", response.payload);
            }
        } catch (error) {
            console.error("Error updating address details:", error);
        }
    };
    
    

    return (
        <>
            <button onClick={showModal} aria-label="Edit Address Details">
                <BtnEditSvg size={30} />
            </button>
            <Modal
                title="Update Address Details"
                open={isModalOpen}
                onCancel={handleCancel}
                footer={null}
                width={600}
            >
                <Form
                    form={form}
                    name="addressDetails"
                    layout="vertical"
                    onFinish={onFinish}
                >
                    <div className="mb-4">
                        <h3 className="text-lg font-semibold mb-2">Current Address</h3>
                        <div className="grid grid-cols-2 gap-4">
                            <Form.Item
                                label="Address"
                                name="street"
                                className="mb-2"
                            >
                                <Input placeholder="Enter street" />
                            </Form.Item>

                            <Form.Item
                                label="City"
                                name="city"
                                className="mb-2"
                            >
                                <Input placeholder="Enter city" />
                            </Form.Item>

                            <Form.Item
                                label="State"
                                name="state"
                                className="mb-2"
                            >
                                <Input placeholder="Enter state" />
                            </Form.Item>

                            <Form.Item
                                label="Zip Code"
                                name="zipCode"
                                className="mb-2"
                            >
                                <Input placeholder="Enter zip code" />
                            </Form.Item>

                            <Form.Item
                                label="Country"
                                name="country"
                                className="mb-2"
                                rules={[{ required: true, message: "Please enter the country!" }]}
                            >
                                <Input placeholder="Enter country" />
                            </Form.Item>
                        </div>
                    </div>

                    <div>
                        <h3 className="text-lg font-semibold mb-2">Permanent Address</h3>
                        <div className="grid grid-cols-2 gap-4">
                            <Form.Item
                                label="Address"
                                name="pAddress"
                                className="mb-2"
                            >
                                <Input placeholder="Enter permanent address" />
                            </Form.Item>

                            <Form.Item
                                label="City"
                                name="pCity"
                                className="mb-2"
                            >
                                <Input placeholder="Enter permanent city" />
                            </Form.Item>

                            <Form.Item
                                label="State"
                                name="pState"
                                className="mb-2"
                            >
                                <Input placeholder="Enter permanent state" />
                            </Form.Item>

                            <Form.Item
                                label="Zip Code"
                                name="pZipCode"
                                className="mb-2"
                            >
                                <Input placeholder="Enter permanent zip code" />
                            </Form.Item>

                            <Form.Item
                                label="Country"
                                name="pCountry"
                                className="mb-2"
                            >
                                <Input placeholder="Enter permanent country" />
                            </Form.Item>
                        </div>
                    </div>

                    <Form.Item className="mt-4">
                        <Button type="primary" htmlType="submit">
                            Update
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
};

export default AddressEditPopup;